import endpoints from "config/endpoints";
import { getEnvVar } from "utils/environment";
import useAxiosRequest from "./common/useAxiosRequest";

const useProdutos = () => {
  const { data, loading, error } = useAxiosRequest({
    autoRun: true,
    url: endpoints.produtos(),
    globalError: false,
    method: "GET",
    headers: {
      cnpj: getEnvVar("CNPJ"),
    },
  });

  return { data, loading, error };
};

export default useProdutos;
